// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useModalContext } from 'components'
import { handleCallsignCascadeMatches } from 'redux/helpers'

const TryAgainForCallsignCascadeMatches = props => {
  const {
    callsignCascadeTriggerData,
    errorMessage,
    handleCallsignCascadeMatches,
  } = props

  const {
    closeContextModal,
    openContextModal,
  } = useModalContext()

  const handleTryAgain = () => handleCallsignCascadeMatches(callsignCascadeTriggerData, openContextModal)

  return (
    <>
      <p>{'Failed to load callsign cascade modal contents.'}</p>
      <p className={'margin-top-1 margin-bottom-1'}>
        {errorMessage}
      </p>
      <div className={'display-flex justify-content-around'}>
        <button
          className={'btn btn-md bg-red hover-inverse'}
          onClick={handleTryAgain}
          type={'button'}>
          {'Try again?'}
        </button>
        <button
          className={'btn btn-md bg-grey-dark hover-inverse'}
          onClick={closeContextModal}
          type={'button'}>
          {'Cancel'}
        </button>
      </div>
    </>
  )
}

TryAgainForCallsignCascadeMatches.propTypes = {
  callsignCascadeTriggerData: array.isRequired,
  errorMessage: string.isRequired,
  handleCallsignCascadeMatches: func.isRequired,
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    handleCallsignCascadeMatches,
  }, dispatch)
)

export default connect(
  null,
  mapDispatchToProps,
)(TryAgainForCallsignCascadeMatches)
